import { FC } from 'react'
import { Button } from '@mui/material'
import { Items } from './items.tsx'
import { MainContent } from '../../components/main-content.tsx'
import { MainContentHeader } from '../../components/main-content-header.tsx'
import { MainContentBody } from '../../components/main-content-body.tsx'
import { Layout } from '../../components/layout.tsx'
import { InventoryItemFormModal } from '../../components/inventory-item-form-modal.tsx'
import { useToggle } from '../../hooks/use-toggle.ts'
import { api, InventoryItemFormData } from '../../redux/api.ts'
import type { InventoryItemModel } from '@itemize/server/models'

export const ItemsPage: FC = () => {
  const { isOpen: isAddModalOpen, toggle: toggleAddModal } = useToggle()
  const [createInventoryItem] = api.useCreateInventoryItemMutation()

  const handleAddItem = () => {
    toggleAddModal(true)
  }

  const handleSubmitItem = async (data: InventoryItemFormData, item: InventoryItemModel | null) => {
    await createInventoryItem(data).unwrap()
  }

  return (
    <Layout>
      <MainContent>
        <MainContentHeader
          title="Items"
          buttons={
            <Button variant="contained" onClick={handleAddItem}>
              Add Item
            </Button>
          }
        />
        <MainContentBody>
          <Items />
        </MainContentBody>
      </MainContent>

      <InventoryItemFormModal
        item={null}
        open={isAddModalOpen}
        onClose={() => toggleAddModal(false)}
        onSubmit={handleSubmitItem}
      />
    </Layout>
  )
}
